import { createContext, useContext } from "react";

/**
 * Read-only mode for member data a partner is *consulting* without edit consent
 * (G-11). Editable controls consume this and render disabled; it defaults to
 * false so the member's own screens and edit-consented on-behalf editing are
 * unaffected. Mirrors the old app's `is_read_only` / `can_edit` gate on the
 * partner questionnaire views.
 */
const ReadOnlyContext = createContext(false);

export const ReadOnlyProvider = ReadOnlyContext.Provider;

export function useReadOnly(): boolean {
  return useContext(ReadOnlyContext);
}
